export const hubResponses = {
    "mock/digitalsignage/admin/hub-id/configuration": {
        "id": "f843f03d-7fed-45e1-9147-23f80cd04d16",
        "appUrl": "sdfsdf",
        "presentationMode": "OnePage"
    },

    "mock/digitalsignage/groups": [
        {id: "123", name: "group 123"},
        {id: "456", name: "group 456"},
        {id: "789", name: "group 789"}
    ],

    "mock/digitalsignage/group/123": {
        id: "123",
        name: "group 123",
    },

    "mock/digitalsignage/group/456": {
        id: "456",
        name: "group 456",
    },

    "mock/digitalsignage/group/789": {
        id: "789",
        name: "group 789",
    },

};